export const PERSONALIZATION_WIDGET = 'personalizationWidget';
export const ENVIRONMENT = 'environment';



// WEBPACK FOOTER //
// ./src/store/modules/environment/types.js